import { LiveStreamType } from "@nova/constants"
import { z } from "zod"

export const droneSchema = z.object({
    flightId: z.string(),
    name: z.string(),
    projectId: z.string(),
    createdBy: z.object({
        userId: z.string(),
    }),
    startedAt: z.number(),
    type: z.enum(LiveStreamType).catch(LiveStreamType.Drone),
})
export type Drone = z.infer<typeof droneSchema>
